import { useEffect, useState } from 'react'
import CustomAutocomplete from 'src/components/algolia/CustomAutocomplete'
import { ArcaplanetLogoHeader } from 'src/components/icons/ArcaplanetLogoHeader'
import { HamburgerMenuHeader } from 'src/components/icons/HamburgerMenuHeader'
import { useGlobalNavigation } from 'src/contexts/global-navigation-context'
import { GoogleMapsProvider } from 'src/contexts/google-maps-context'
import { useStoreContext } from 'src/contexts/store-context'
import FavouriteStoreModal from '../Subheader/Store/FavouriteStoreModal'
import StorePickerSidebar from '../Subheader/Store/StorePickerSidebar'
import {
  getStoreName,
  useSlidingAnimation,
} from '../Subheader/Store/utils/utils'
import { CartInfo } from './CartInfo'
import { UserInfo } from './UserInfo'

export const Header = () => {
  const [isSidebar, setIsSidebar] = useState(false)
  const [isOpen, setIsOpen] = useState(false)
  const { setOpenCloseMenu } = useGlobalNavigation()
  const { favouriteStore, showStoreData } = useStoreContext()
  const { shouldRender } = useSlidingAnimation(isSidebar)

  const handleOpenClose = () => {
    setOpenCloseMenu(true)
  }

  const closeModal = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.preventDefault()
    e.stopPropagation()
    setIsOpen(false)
  }
  const openSidebar = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.preventDefault()
    e.stopPropagation()
    setIsSidebar(true)
    setIsOpen(false)
  }

  const handleOpenClick = () => {
    if (favouriteStore?.id) {
      setIsOpen((prev) => !prev)
    } else {
      setIsSidebar(true)
    }
  }

  useEffect(() => {
    return () => {
      setIsSidebar(false)
    }
  }, [])

  return (
    <>
      <div className="bg-yellow global-header">
        <div className="px-6 lg:px-10 pt-4 md:pt-4 3xl:pt-6 md:pb-4 3xl:pb-6 relative">
          <div className="flex flex-nowrap items-center justify-between w-full gap-2 md:gap-6">
            <div className="flex flex-row flex-nowrap items-center justify-between w-full md:w-fit gap-2 md:gap-6">
              <button
                aria-label="Categorie"
                className="flex flex-row flex-nowrap gap-1 items-center cursor-pointer bg-yellow global-navigation-open"
                onClick={handleOpenClose}
              >
                <HamburgerMenuHeader />
                <span className="hidden lg:block text-sm font-semibold tracking-[0.035px] !leading-[130%]">
                  Categorie
                </span>
              </button>
              <a
                href="/"
                className="block mx-auto md:mx-0"
                aria-label="Arcaplanet Logo"
              >
                <ArcaplanetLogoHeader />
              </a>
            </div>
            <div className="hidden md:flex max-w-[780px] flex-grow relative z-[4]">
              {/* TODO(algolia-searchbar): come as-is, search montata desktop+mobile.
                  Per ora stesso componente; differenze UX breakpoint solo se serviranno. */}
              <CustomAutocomplete />
            </div>
            <div className="flex flex-row flex-nowrap gap-3 md:gap-6 items-center">
              <UserInfo />
              <CartInfo />
            </div>
          </div>
        </div>
      </div>
      <div className="flex top-0 md:hidden sticky px-6 pt-3 pb-2 w-full bg-yellow justify-center z-[3]">
        {/* TODO(algolia-searchbar): mobile — stesso componente del desktop per ora */}
        <CustomAutocomplete />
      </div>
      <div
        onClick={handleOpenClick}
        className="flex md:hidden px-6 items-center pt-2 pb-3 bg-yellow text-xs gap-1 relative"
      >
        {showStoreData ? (
          <>
            {favouriteStore?.id ? (
              <>
                <span className="shrink-0">Il tuo negozio:</span>
                <span className="font-semibold whitespace-nowrap text-ellipsis min-w-[0] overflow-hidden">
                  {getStoreName(favouriteStore, 'mobile')}
                </span>
                <span className="flex items-center shrink-0 justify-center arca-ico-chevron-down text-[18px]"></span>
              </>
            ) : (
              <>
                <span className="font-semibold whitespace-nowrap text-ellipsis">
                  Seleziona il tuo negozio preferito
                </span>
                <span className="flex items-center justify-center arca-ico-chevron-down text-[18px]"></span>
              </>
            )}
          </>
        ) : (
          <div className="animate-pulse w-full">
            <div className="h-5 bg-gray-500 rounded"></div>
          </div>
        )}

        {isOpen && (
          <FavouriteStoreModal
            favouriteStore={favouriteStore}
            closeModal={closeModal}
            openSidebar={openSidebar}
            isMobile
          />
        )}
      </div>

      <GoogleMapsProvider>
        {shouldRender && (
          // createPortal(
          <StorePickerSidebar
            isSidebar={isSidebar}
            setIsSidebar={setIsSidebar}
          />
          //   document?.body
        )}
      </GoogleMapsProvider>
    </>
  )
}
